import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tokens.css';
import './index.css';
import './i18n';
import { detectLanguageByGeo } from './i18n';
import { startGeoHeaderSync } from './utils/geoHeaders';
import App from './App';

// Resolvemos el idioma por geo-IP ANTES del primer render para evitar el
// parpadeo de fallback → idioma correcto. detectLanguageByGeo nunca rechaza
// (try/catch interno + timeout de 1.5s), así que el render siempre ocurre.
detectLanguageByGeo().finally(() => {
  // El país/idioma resueltos viajan como headers en todo request: el backend
  // los usa para decidir el idioma de los correos transaccionales.
  startGeoHeaderSync();
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode><App /></React.StrictMode>
  );
});
